import "../styles/about.css";

export default function About({ t }) {
  return (
    <section id="about" className="about-compact" aria-labelledby="about-heading">
      <div className="about-compact-inner">
        <div className="about-compact-main">
          <img className="about-compact-photo" src="/images/about.jpg" alt="" loading="lazy" />
          <div className="about-compact-copy">
            <p className="about-compact-label">{t.about}</p>
            <h2 id="about-heading">{t.aboutTitle}</h2>
            <p className="about-compact-description">{t.aboutText}</p>
            <ul className="about-compact-benefits">
              {t.aboutList.map(item => <li key={item}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m5 12 4 4L19 6" /></svg>{item}</li>)}
            </ul>
          </div>
        </div>
        <dl className="about-compact-stats">
          <div><dt>{t.stats.transports}</dt><dd>12 500+</dd></div>
          <div><dt>{t.stats.years}</dt><dd>14+</dd></div>
          <div><dt>{t.stats.clients}</dt><dd>99%</dd></div>
        </dl>
      </div>
    </section>
  );
}